import { media, styled } from '@styles';

export const Wrapper = styled.div`
  margin: 150px auto;
  ${media.largeScreen`
    width: auto;
    margin: 150px auto 50px auto;
  `}
  ${media.mediumScreen`
    margin: 80px auto 50px auto;
    width: 100%;
    padding: 0 63px;
  `}
  ${media.smallScreen`
    margin: 60px auto 50px auto;
    padding: 0 25px;
  `}
`;

export const Header = styled.div`
  max-width: 1492px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const Content = styled.div`
  max-width: 1492px;
  width: 100%;
  display: flex;
  margin: auto;
`;

export const Title = styled.h1`
  text-align: center;
  position: relative;
  line-height: 1em;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h2FontSize};
  font-weight: lighter;
  color: ${(props) => props.theme.colors.baseFont};
  letter-spacing: -0.5px;
  padding: 40px 0 0;
  ${media.largeScreen`
    padding: 30px 0 0;
  `}
  ${media.smallScreen`
    padding: 15px 0 0;
  `}
  * {
    font: inherit;
  }
`;

export const Excerpt = styled.div`
  text-align: center;
  position: relative;
  line-height: 1em;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.baseFontSize};
  font-weight: lighter;
  color: ${(props) => props.theme.colors.baseFont};
  letter-spacing: -0.5px;
  padding: 18px 0 18px 0;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
  ${media.smallScreen`
    padding: 12px 0 12px 0;
  `}
  * {
    font: inherit;
  }
`;

export const Filters = styled.div`
  // width: calc(342 / 1492 * 100%);
  // margin-right: 42px;
  // flex-shrink: 0;
  // ${media.largeScreen`
  //   width: 273px;
  //   margin-right: 21px;
  // `}
  // ${media.mediumScreen`
  //   display: none;
  // `}
`;

export const ProductList = styled.div`
  width: 100%;
  min-height: calc(100vh - 300px);
`;
